// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Загружаем переводы
import translationEN from './locales/en.json';
import translationRU from './locales/ru.json';
import translationES from './locales/es.json';
import translationDE from './locales/de.json';
import translationPT from './locales/pt.json';
import translationAR from './locales/ar.json';
import translationKK from './locales/kk.json';

// Ресурсы для переводов
const resources = {
    en: {
        translation: translationEN
    },
    ru: {
        translation: translationRU
    },
    es: {
        translation: translationES
    },
    de: {
        translation: translationDE
    },
    pt: {
        translation: translationPT
    },
    ar: {
        translation: translationAR
    },
    kk: {
        translation: translationKK
    }
};

i18n
    // Определяет язык пользователя с помощью браузера
    .use(LanguageDetector)
    // Интеграция с React
    .use(initReactI18next)
    // Инициализация i18next
    .init({
        resources,
        fallbackLng: 'en', // Язык по умолчанию, если не удается определить
        debug: process.env.NODE_ENV === 'development',

        interpolation: {
            escapeValue: false // Реакт уже защищает от XSS
        },

        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage']
        }
    });

export default i18n;